import {
  Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy,
  OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { Subscription ,  Observable ,  of } from 'rxjs';
import { InstrumentPillSecurity, Security, SearchInput } from './instrument-pill.model';
import { InstrumentPillSearchQuery, InstrumentPillSearchResult } from './instrument-pill.model';
import { InstrumentPillService } from './instrument-pill.service';
import { catchError, first, finalize, map } from 'rxjs/operators';




@Component({
  selector: 'instrument-pill',
  templateUrl: './instrument-pill.component.html',
  styleUrls: ['./instrument-pill.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstrumentPillComponent implements OnInit, OnChanges, OnDestroy {

  @Input() instrumentId: number;
  @Input() arbitrageId: number;
  @Input() instrumentKey: string;
  @Input() minLength: number = 2;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() title: string;
  @Input() opened: boolean = false;
  @Input() large: boolean = false;
  @Input() scope: string = 'DEFAULT';  // scope for last used securities
  @Input() serviceName: string = 'security.search';
  @Input() searchParams: any;
  @Input() showClearSelection: boolean = false;
  @Input() clearSelectionLabel: string;
  @Input() filterInstruments: (instruments: InstrumentPillSecurity[]) => InstrumentPillSecurity[];

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onClearSelection = new EventEmitter();
  @Output() openedChanged = new EventEmitter<boolean>();
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onSecuritySelected = new EventEmitter<InstrumentPillSecurity>();
  @Output() onSearch = new EventEmitter<SearchInput>();
  @Output() onError = new EventEmitter<Error>();

  @ViewChild('search') inputElemRef: ElementRef;

  security: InstrumentPillSecurity;
  loading: boolean = false;
  searchResult: Observable<InstrumentPillSearchResult>;
  _searchResult: InstrumentPillSearchResult;
  findSecuritySubscription: Subscription;
  lastUsedSecurities: Observable<InstrumentPillSecurity[]>;
  init: boolean = true;
  message: string;
  selectedIndex: number = null;

  private securitiesLength: number;

  private inputFocused: boolean = false;

  private _lastUsedSecurities: InstrumentPillSecurity[];

  private subscription: Subscription;

  private searchSubscriptiton: Subscription;

  private triggerrequestTimer: any = null;

  @HostListener('document:keydown', ['$event', '$event.target'])
  onKeyDown(event: KeyboardEvent, targetElement: HTMLElement) {

    event.stopPropagation();

    if (event.keyCode === 27) { // escape
      this.setOpened(false);
    }

    if (this.selectedIndex === null || this.selectedIndex === undefined) { // initial

      if (event.keyCode === 40) { // if down
        this.selectedIndex = 0;
        // this.inputElemRef.nativeElement.blur();
        this.inputFocused = false;
      }

    } else {

      if (this.opened) {
        if (event.keyCode === 38) { // arrow up

          if (this.inputFocused && this.selectedIndex === null) {
            return;
          }

          this.selectedIndex--;

          if (this.selectedIndex <= -1) { // if input selected
            this.selectedIndex = null;
            this.inputElemRef.nativeElement.focus();
            this.inputFocused = true;
          }

        } else if (event.keyCode === 40) { // arrow down

          this.selectedIndex++;
          const maxLengtht = this._searchResult ? 1 : 0; // for last li (weitere suchErgenisse)

          if (this.selectedIndex >= this.securitiesLength + maxLengtht) {
            this.selectedIndex = 0;
          }

        } else if (event.keyCode === 13) { // enter

          if (this._searchResult) {

            if (this.selectedIndex === this.securitiesLength) {
           //   this.triggerSearch({ query: this.inputElemRef.nativeElement.value, params: this.searchParams });
            } else {
              this.selectSecurity(this._searchResult.securities[this.selectedIndex]);
            }

          } else {
            this.selectSecurity(this._lastUsedSecurities[this.selectedIndex]);
          }

        }
      }
    }
  }

  constructor(
    private service: InstrumentPillService,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.lastUsedSecurities = this.service.getLastUsedSecurities(this.scope).pipe(map(securities => {
      if (this.filterInstruments) {
        return this.filterInstruments(securities);
      }
      this.securitiesLength = securities.length;
      this._lastUsedSecurities = securities;

      return securities;
    }));

    setTimeout(() => {
      this.init = false;
      this.cdRef.markForCheck();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.instrumentId || changes.arbitrageId || changes.instrumentKey) {
      const params: Partial<any> = {};
      let instrumentParamDefined = false;

      if (changes.instrumentId && changes.instrumentId.currentValue) {
        params.instrumentId = changes.instrumentId.currentValue;
        instrumentParamDefined = true;
      }

      if (changes.arbitrageId && changes.arbitrageId.currentValue) {
        params.arbitrageId = changes.arbitrageId.currentValue;
        instrumentParamDefined = true;
      }

      if (changes.instrumentKey && changes.instrumentKey.currentValue) {
        params.instrumentKey = changes.instrumentKey.currentValue;
        instrumentParamDefined = true;
      }

      if (instrumentParamDefined) {
        if (this.findSecuritySubscription) {
          this.findSecuritySubscription.unsubscribe();
        }

        this.findSecuritySubscription = this.service.findSecurity(params)
          .subscribe(
            (security: InstrumentPillSecurity) => {
              this.security = security;
              this.cdRef.markForCheck();
            },
            (e: any) => {
              this.onError.emit(e);
            }
          );
      } else {
        this.security = undefined;
      }
    }
  }

  mouseEnter(index: number) {
    this.selectedIndex = index;
  }

  onKeyUp($event: KeyboardEvent) {

    if ($event.keyCode === 37 || $event.keyCode === 38 || $event.keyCode === 39 || $event.keyCode === 40) {
      return;
    }

    const target = <HTMLInputElement>$event.target;

    // select security on enter if only one security in result
    if ($event.keyCode === 13) {
      if (this._searchResult && this._searchResult.securities.length === 1) {
        this.selectSecurity(this._searchResult.securities[0]);
        return;
      }
    }

    if (target.value.length >= this.minLength) {

      if (this.triggerrequestTimer) {
        clearTimeout(this.triggerrequestTimer);
      }

      this.triggerrequestTimer = setTimeout(() => {
        this.getSearchResult({ query: target.value, params: this.searchParams, serviceName: this.serviceName });
      }, 300);

    } else {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }

      this.searchResult = null;
      this._searchResult = null;
    }
  }

  setOpened(opened: boolean) {

    if (opened) {
        this.inputFocused = true;
        this.inputElemRef.nativeElement.focus();
    } else {
      this.selectedIndex = null;
    }

    this.opened = opened;
    this.openedChanged.emit(this.opened);
  }

  // triggerSearch(searchInput: SearchInput) {
  //   this.setOpened(false);
  //   this.onSearch.emit(searchInput);
  //   this.searchSubscriptiton = this.searchService.openSearchDialog(searchInput).pipe(first()).subscribe((security: Security) => {
  //     this.selectSecurity(security);
  //   });
  // }

  getSearchResult(searchQuery: InstrumentPillSearchQuery) {
    this.loading = true;
    this.message = '';

    this.selectedIndex = null;
    this.searchResult = this.service.getSearchResult(searchQuery).pipe(
      catchError(e => {
        if (e.code === 'INSTRUMENT_NOT_FOUND') {
          this.message = 'WIDGETS.BOND_CALCULATOR.INSTRUMENT_QUICK_SEARCH.INSTRUMENT_NOT_FOUND';
        }
        this.onError.emit(e);
        return of(null);
      })
    );
    this.subscription = this.searchResult.pipe(
      first(),
      finalize(() => {
        this.loading = false;
        this.cdRef.markForCheck();
      })
    ).subscribe(
      searchResult => {
        if (searchResult && this.filterInstruments) {
          searchResult.securities = this.filterInstruments(searchResult.securities);
        }
        this._searchResult = searchResult;
        if (this._searchResult) {
          this.securitiesLength = this._searchResult.securities.length;   // reload length
        }


      }
    );
  }

  clearSelection() {
    this.setOpened(false);
    this.inputElemRef.nativeElement.value = '';
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.searchResult = null;
    this._searchResult = null;

    this.onClearSelection.next();
  }

  selectSecurity(security: InstrumentPillSecurity | Security) {
    // count instrument for mostClicked
  

    this.service.addToLastUsedSecurities(security, this.scope);
    this.onSecuritySelected.emit(security);
    this.setOpened(false);
    this.inputElemRef.nativeElement.value = '';
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.searchSubscriptiton) {
      this.subscription.unsubscribe();
    }

    this.searchResult = null;
    this._searchResult = null;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.searchSubscriptiton) {
      this.subscription.unsubscribe();
    }

    if (this.findSecuritySubscription) {
      this.findSecuritySubscription.unsubscribe();
    }
  }
}
